export const WHISKEY_TYPES = [
  'Bourbon', 'Rye', 'Wheated Bourbon', 'High Rye Bourbon',
  'Single Malt', 'Tennessee Whiskey', 'Blended', 'Other',
];

export const FINISH_CASKS = [
  'Port', 'Sherry', 'Rum', 'Wine', 'Cognac',
  'Toasted Oak', 'New Oak', 'Beer / Stout', 'Maple', 'Custom',
];

export const PRESERVATION_METHODS = [
  { value: 'none', label: 'None', description: 'Standard cork or cap.' },
  { value: 'vacuum', label: 'Vacuum Stopper', description: 'Removes some oxygen from headspace. Reduces oxidation ~30%.' },
  { value: 'inert_gas', label: 'Inert Gas (Private Preserve)', description: 'Displaces oxygen with nitrogen/argon blanket. Reduces oxidation ~60%. Most effective method.' },
  { value: 'decanted', label: 'Decanted to Smaller Bottle', description: 'Minimizes headspace by moving to a smaller container. Reduces oxidation ~50%.' },
];

// ── Flavor Taxonomy v2 — BarrelNotes Final Locked 2026-04-30 ──────────────────
// Two-tier structure. Keys = broad chips. Values = tier 2 descriptors.
// Nose and Palate share broad categories but have phase-appropriate tier 2.
// Finish uses Character chips as the broad tier, with tier 2 per character.

export const NOSE_FLAVORS = {
  'Sweet':         ['Vanilla', 'Honey', 'Caramel', 'Maple'],
  'Grain':         ['Corn', 'Rye', 'Wheat', 'Biscuit', 'Cereal'],
  'Oak':           ['Cedar', 'Toasted Oak', 'Tobacco', 'Sawdust'],
  'Spice':         ['Black Pepper', 'Cinnamon', 'Nutmeg', 'Mint', 'Anise'],
  'Fruit & Floral':['Banana/Tropical', 'Citrus', 'Light Fruit', 'Dark Fruit', 'Dried Fruit', 'Floral/Perfume'],
};

export const PALATE_FLAVORS = {
  'Sweet':         ['Caramel', 'Butterscotch', 'Brown Sugar', 'Toffee', 'Maple'],
  'Grain':         ['Corn', 'Rye', 'Cornbread', 'Malt'],
  'Oak':           ['Charred Oak', 'Leather', 'Dark Chocolate'],
  'Spice':         ['Black Pepper', 'Clove', 'Cinnamon', 'Ginger'],
  'Fruit & Floral':['Banana/Tropical', 'Citrus', 'Light Fruit', 'Dark Fruit', 'Dried Fruit'],
};

export const FINISH_FLAVORS = {
  'Sweet':   ['Vanilla', 'Caramel', 'Honey', 'Chocolate'],
  'Dry':     ['Oaky', 'Astringent', 'Clean'],
  'Warming': ['Gentle', 'Building', 'Hot', 'Burning'],
  'Bitter':  ['Dark Chocolate', 'Coffee', 'Tobacco', 'Walnut'],
  'Spicy':   ['Pepper', 'Cinnamon', 'Clove', 'Tingly'],
};

// ── Mouthfeel — Palate expansion chips ───────────────────────────────────────
export const MOUTHFEEL_OPTIONS = [
  'Light', 'Creamy', 'Medium', 'Full', 'Oily', 'Chewy', 'Dry',
];

// ── Nose Intensity — Nose expansion chips ────────────────────────────────────
export const NOSE_INTENSITY_OPTIONS = ['Subtle', 'Moderate', 'Bold'];

// ── Heat — Palate expansion chips ────────────────────────────────────────────
export const HEAT_OPTIONS = ['Gentle', 'Warming', 'Hot', 'Burning'];

// ── Color — Appearance phase slider stops ────────────────────────────────────
export const COLOR_STOPS = [
  'Pale Straw', 'Gold', 'Amber', 'Deep Amber', 'Copper', 'Mahogany',
];

// ── Finish Length — Finish phase base chips ───────────────────────────────────
export const FINISH_LENGTH_OPTIONS = ['Short', 'Medium', 'Long'];

// ── Finish Fade — Finish expansion chips ─────────────────────────────────────
export const FINISH_FADE_OPTIONS = ['Fades Quickly', 'Lingers', 'Evolves'];

// ── Color Appearance — Clarity and Viscosity expansion ───────────────────────
export const CLARITY_OPTIONS = ['Clear', 'Slight Haze', 'Cloudy'];
export const VISCOSITY_OPTIONS = ['Thin', 'Medium', 'Thick'];

export const REASON_TAGS = [
  'Well Balanced', 'Rich', 'Smooth', 'Complex',
  'Too Dry', 'Too Hot', 'Too Spicy', 'Too Sweet',
  'Simple', 'Harsh', 'Short Finish', 'Exceptional',
];

export const SERVING_STYLES = ['Neat', 'Few Drops Water', 'Ice', 'Custom'];

export const VOLUME_OPTIONS = [
  { value: 200,  label: '200mL (Miniature)' },
  { value: 375,  label: '375mL (Half Bottle)' },
  { value: 750,  label: '750mL (Standard)' },
  { value: 1000, label: '1000mL (Liter)' },
  { value: 1750, label: '1750mL (Handle)' },
];